export default "__VITE_ASSET__DafnE2hy__"